export default "__VITE_ASSET__c93b7072__"